import React, { useState } from "react";
import { Box, Grid } from "@material-ui/core";
import LoadableComponent from "../../../shared/Loading/LoadableComponent";
import RoomSchame from "./RoomSchame";
import { Assort } from "../../../models/Assort";
import { ZoneSeats } from "../../../models/ZoneSeats";
import { RowZone } from "../../../models/RowZone";
import { Seat } from "../../../models/Seat";
import TicketsSeatModal from "./TicketsSeatModal";
import { useDispatch, useSelector } from "react-redux";
import { addTicketWithSeatToBasket } from "../../../store/basket/basketActions";
import { Exercise } from "../../../models/Exercise";
import { TicketAccess } from "../../../models/TicketAccess";
import getId from "../../../utils/getId";
import { TicketBillLine } from "../../../models/TicketBillLine";
import hasValue from "../../../utils/hasValue";
import { BLOCK_SEAT } from "../../../api/apiRoutes";
import { Identifiable } from "../../../models/Identifiable";
import { get } from "../../../api";
import { setErrors } from "../../../store/alerts/alertsActions";
import { State } from "../../../store";
import BackButton from "../../../shared/NavigationDrawer/BackButton";
import MiniRoomSchame from "../MiniRoomSchame";
import Hidden from "@material-ui/core/Hidden";
import FinalizeBasketBtn from "../../../shared/NavigationDrawer/FinalizeBasketBtn";

declare const config: { EXERCISE_IDS_MANY_TICKET: string };

const getTicketWithSeat = (assort: Assort, exercise: Exercise, rowZone: RowZone, seat: Seat) => {
  return {
    assort,
    quantity: 1,
    ticketAccessList: [{ exercise, status: "Added", seat, rowZone } as TicketAccess],
    tempId: `${getId(seat)}`
  } as TicketBillLine;
};

interface IProps {
  loading: boolean;
  ticketList: Assort[];
  zoneScheme: ZoneSeats | null;
  handleClickSeat: (rowZone: RowZone, seat: Seat) => void;
  activeStep: number;
  setActiveStep: (value: number) => void;
  openTicketModal: boolean;
  onCloseTicketModal: () => void;
  refreshPlanSeat: () => void;
  exercise: Exercise;
}

const SeatsView: React.FC<IProps> = ({
  activeStep,
  setActiveStep,
  loading,
  ticketList,
  zoneScheme,
  handleClickSeat,
  openTicketModal,
  onCloseTicketModal,
  refreshPlanSeat,
  exercise
}: IProps) => {
  const [row, setRow] = useState<RowZone>({} as RowZone);
  const [seat, setSeat] = useState<Seat>({} as Seat);
  const [section, setSection] = useState<Seat>({} as Seat);
  const dispatch = useDispatch();
  const basket = useSelector((state: State) => state.basket.basket);

  const handleSelectSeat = (rowZone: RowZone, seat: Seat) => {
    handleClickSeat(rowZone, seat);
    setRow(rowZone);
    if (seat.status === "X") {
      setSection(seat);
    } else {
      setSeat(seat);
    }
  };

  const handleSelectTicket = (assort: Assort) => {
    onCloseTicketModal();
    if (getId(exercise) === config.EXERCISE_IDS_MANY_TICKET) {
      const qnt = basket.filter(item => getId(item.ticketAccessList[0].exercise) === config.EXERCISE_IDS_MANY_TICKET)
        .length;
      if (qnt < 4) {
        blockSeat(seat);
        dispatch(addTicketWithSeatToBasket(getTicketWithSeat(assort, exercise, row, seat)));
      } else {
        dispatch(setErrors(["Na tą imprezę możesz wybrać jednorazowo 4 bilety."]));
      }
    } else {
      blockSeat(seat);
      dispatch(addTicketWithSeatToBasket(getTicketWithSeat(assort, exercise, row, seat)));
    }
  };

  const handleClickPrev = () => {
    if (hasValue(seat)) {
      setSeat({} as Seat);
      setRow({} as RowZone);
      refreshPlanSeat();
    } else if (hasValue(section)) {
      setSection({} as Seat);
      setRow({} as RowZone);
      refreshPlanSeat();
    } else {
      setActiveStep(activeStep - 1);
    }
  };

  const blockSeat = async (seatIds: Identifiable) => {
    await get(BLOCK_SEAT(exercise, seatIds));
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ position: "relative", marginTop: 20, marginBottom: 100 }}>
        <LoadableComponent loading={loading}>
          <Box style={{ marginTop: 20, marginBottom: 20, width: "100%", textAlign: "center" }}>{exercise.name}</Box>
          {zoneScheme && (
            <React.Fragment>
              {/*<Grid item xs={12} style={{ marginTop: 20, marginBottom: 100, position: "relative" }}>*/}
              <RoomSchame zoneScheme={zoneScheme} onSelectedSeat={handleSelectSeat} section={section} />
              {/*</Grid>*/}
            </React.Fragment>
          )}
          <Hidden mdDown>
            {getId(section) && <MiniRoomSchame onSelectSeat={handleSelectSeat} selectedSeat={section} />}
          </Hidden>
          {openTicketModal && (
            <TicketsSeatModal
              ticketList={ticketList}
              open={openTicketModal}
              onClose={onCloseTicketModal}
              onSelectTicket={handleSelectTicket}
            />
          )}
        </LoadableComponent>
      </Grid>

      <BackButton onClick={handleClickPrev} />
      <FinalizeBasketBtn />
    </React.Fragment>
  );
};

export default SeatsView;
